import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Aviation, Order } from "../../../services";
import { useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import { toast } from "react-toastify";
import { requestErrorDisplay } from "../../../utils";
import { useTranslation } from "react-i18next";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomButton from "../../custom/custom-button/CustomButton";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import style from "./confirmModal.module.scss";

const OrdersDelete = ({ item, onClose, onUpdateData, setIsOpen, isAirOrder = false }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);

  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const deleteOrders = () => {
    if (!comment.trim()) {
      const message = t("cancelOrder.deleteReasonRequired");
      setError(message);
      toast.error(message);
      return;
    }
    setError("");

    const Service = isAirOrder ? Aviation : Order;

    setIsLoading(true);
    Service.deleteOrder(item.id, user.name, comment.trim())
      .then(() => {
        setError("");
        if (setIsOpen) {
          setIsOpen(false);
        }
        onClose();
        onUpdateData();
        toast.info(t("cancelOrder.orderSuccessfullyDeleted"));
      })
      .catch((error) => {
        requestErrorDisplay(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return ReactDOM.createPortal(
    <div className={style.modalOverlay} data-portal-modal="true">
      <div className={style.modalContainer}>
        <div className={style.topbar}>
          <h2 className={style.modalTitle}>{t("cancelOrder.deleteTitle")}</h2>
          <button
            type="button"
            className={style.closeBtn}
            onClick={onClose}
            aria-label={t("cancelOrder.close")}
          >
            <CloseIconNew />
          </button>
        </div>

        <div className={style.card}>
          <CustomInput
            labelText={t("cancelOrder.deleteReasonLabel")}
            placeholder={t("cancelOrder.deleteReasonPlaceholder")}
            isBgGray
            errorText={!comment.trim() && error}
            inputType="text"
            value={comment}
            onChangeValue={(value) => {
              setComment(value);
              if (value) setError("");
            }}
          />
        </div>

        <div className={style.modalActions}>
          <CustomButton
            isCancel
            text={t("cancelOrder.cancelButton")}
            onClick={onClose}
            disabled={isLoading}
          />
          <CustomButton
            isNavy
            text={t("cancelOrder.submitButton")}
            onClick={deleteOrders}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default OrdersDelete;
